
export default {
  props: {
    broadcast: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isAvailable() {
      return this.$dateFns.isPast(this.$dateFns.parseISO(this.broadcast.date));
    },
  },
};
